import React from 'react';
import styled from 'styled-components';
import { COLORS, BackButton, Size, ComponentM, ComponentTextStyle } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BreadcrumbTopSection from '../../../../commonComponents/BreadcrumbTopSection';
import { StepContainer, StepHeader, StepTitle, StepDescription } from './StepComponents';
import { selectMarket, buildMarketPath } from '../../../../store/slices/globalConfigSlice';
import posthog from 'posthog-js';


const CategoryButton = styled.div`
    border-radius: 8px;
    border: 1px solid ${COLORS.neutral_200};
    display: flex;
    padding: 16px 16px;
    align-items: flex-start;
    align-self: stretch;
`;


interface Step0Props {
  onNext: (step?: number) => void;
  handleCategoryChange: (category: string) => void;
  onPrevious: () => void;
}

const Step0: React.FC<Step0Props> = ({ onNext, handleCategoryChange, onPrevious }) => {
  const { t } = useTranslation(['translation', 'qcprSupport']);
  const currentMarket = useSelector(selectMarket);

  return (
    <StepContainer>
        <BreadcrumbTopSection 
            setPadding={false}
            breadcrumb={[
                { text: t('Home', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/') },
                { text: t('Software and Apps', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/category/software-and-apps') },
                { text: t('QCPR App', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/category/software-and-apps/product/qcpr-app') },
                { text: t('Troubleshooting', { ns: 'qcprSupport' }) }
            ]}
        />

        <StepHeader>
            <StepTitle>{t('Choose a topic', { ns: 'qcprSupport' })}</StepTitle>
            <StepDescription>{t('Option that best describes what you need help with.', { ns: 'qcprSupport' })}</StepDescription>
        </StepHeader>
        
        <CategoryButton onClick={() =>{ 
                posthog.capture('SUPP-QcprSupport-CategorySelected', {
                    category: "Manikin's connectivity",
                    step: 0
                });
                handleCategoryChange("Manikin's connectivity");
                onNext();
            }}>
            <ComponentM textStyle={ComponentTextStyle.Bold}>
                {t("Manikin's connectivity", { ns: 'qcprSupport' })}
            </ComponentM>
        </CategoryButton>

        <CategoryButton onClick={() =>{ 
                posthog.capture('SUPP-QcprSupport-CategorySelected', {
                    category: 'Manikin not working',
                    step: 0
                });
                handleCategoryChange('Manikin not working');
                onNext();
            }}>
            <ComponentM textStyle={ComponentTextStyle.Bold}>
                {t('Manikin not working', { ns: 'qcprSupport' })}
            </ComponentM>
        </CategoryButton>

        <CategoryButton onClick={() =>{ 
                posthog.capture('SUPP-QcprSupport-CategorySelected', {
                    category: 'Firmware',
                    step: 0
                });
                handleCategoryChange('Firmware');
                onNext();
            }}>
            <ComponentM textStyle={ComponentTextStyle.Bold}>
                {t('Firmware', { ns: 'qcprSupport' })}
            </ComponentM>
        </CategoryButton>

        <CategoryButton onClick={() =>{ 
                posthog.capture('SUPP-QcprSupport-CategorySelected', {
                    category: 'App crashes',
                    step: 0
                });
                handleCategoryChange('App crashes');
                onNext();
            }}>
            <ComponentM textStyle={ComponentTextStyle.Bold}>
                {t('App crashes', { ns: 'qcprSupport' })}
            </ComponentM>
        </CategoryButton>

        <CategoryButton 
            onClick={() => {
                posthog.capture('SUPP-QcprSupport-CategorySelected', {
                    category: 'Log in / Sign up',
                    step: 0,
                    skipped_to_step: 9
                });
                handleCategoryChange('Log in / Sign up');
                onNext(9);
            }}>
            <ComponentM textStyle={ComponentTextStyle.Bold}>
                {t('Log in / Sign up', { ns: 'qcprSupport' })}
            </ComponentM>
        </CategoryButton>

        <CategoryButton 
            onClick={() => {
                posthog.capture('SUPP-QcprSupport-CategorySelected', {
                    category: 'Other',
                    step: 0,
                    skipped_to_step: 9
                });
                handleCategoryChange('Other');
                onNext(9);
            }}>
            <ComponentM textStyle={ComponentTextStyle.Bold}>
                {t('Other', { ns: 'qcprSupport' })}
            </ComponentM>
        </CategoryButton>

    </StepContainer>
  );
};

export default Step0;
